import React from 'react';
import { Container, Typography } from '@mui/material';

const Orders = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4">Mis Pedidos</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Página de pedidos en construcción...
      </Typography>
    </Container>
  );
};

export default Orders; 